(() => {
  const initGuide = (root = document) => {
    root.querySelectorAll('[data-dartsrx-hero]').forEach((hero) => {
      if (hero.dataset.guideReady === 'true') return;

      const openButton = hero.querySelector('[data-dartsrx-guide-open]');
      const dialogId = openButton?.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!openButton || !dialog) return;

      const closeButton = dialog.querySelector('[data-dartsrx-guide-close]');
      const guideLinks = dialog.querySelectorAll('.dartsrx-guide__link');

      const openGuide = () => {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        document.documentElement.classList.add('dartsrx-guide-is-open');
      };

      const closeGuide = () => {
        if (typeof dialog.close === 'function' && dialog.open) {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
        document.documentElement.classList.remove('dartsrx-guide-is-open');
      };

      openButton.addEventListener('click', openGuide);
      closeButton?.addEventListener('click', closeGuide);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeGuide();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('dartsrx-guide-is-open');
      });
      guideLinks.forEach((link) => link.addEventListener('click', closeGuide));

      hero.dataset.guideReady = 'true';
    });
  };

  initGuide();
  document.addEventListener('shopify:section:load', (event) => initGuide(event.target));
})();
